export default "{\n    \"title\": \"Request Service from Vendor\",\n    \"subtitle\": \"Create and submit work orders to vendors\"\n}\n"